module.exports = __webpack_public_path__ + "img/precio.921f34e7.svg";